<textarea class="form-control" [placeholder]="placeholder" [formControl]="control"
    [ngClass]="{ 'is-invalid': control.invalid && (control.touched || submitted) }"></textarea>
<div *ngIf="control.invalid && (control.touched || submitted)" class="invalid-feedback">
    <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
</div>